import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

import { MapEditorLayer } from "../types/mapEditorTypes";

export const MAP_EDITOR_LAYER_GET_BY_ID = gql(`
query MapEditorLayerGetById($id: ID!) {
    mapEditorLayerGetById(id: $id) {
        id
        name
        config
        color
        style
        addressImportJobId
        showToClientUser
    }
}
`);

export default function useMapEditorLayerGetById(id: string) {
    const { data, loading, error } = useQuery(MAP_EDITOR_LAYER_GET_BY_ID, {
        variables: { id },
        fetchPolicy: "cache-first",
    });

    return {
        loading,
        error,
        data: data?.mapEditorLayerGetById as MapEditorLayer | undefined,
    };
}
